import {combineReducers} from 'redux'
import auth from './auth'
import credit from './credit'
import user from './user'
import utils from './utils'
import document from './document'
import backOffice from './backOffice'
import firmaCCR from './firmaCCR'
import solicitudCredito from './solicitudCredito'
import {connectRouter} from "connected-react-router";

const rootReducer = (history) => combineReducers({
  auth,
  credit,
  user,
  utils,
  document,
  backOffice,
  firmaCCR,
  solicitudCredito,
  router: connectRouter(history)
})

export default rootReducer
